import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,[(_vm.loading)?[_c(VContainer,{staticClass:"flex-col",attrs:{"fluid":""}},[_c(VSkeletonLoader,{attrs:{"type":"list-item"}})],1)]:_c(VContainer,{attrs:{"fluid":""}},[_c(VListItemContent,[_c('div',{staticClass:"flex-shrink"},[_vm._v(_vm._s(_vm.invoice.id)+": "+_vm._s(_vm.invoice.recipient.email)+" "+_vm._s(_vm.invoiceNotificationResponse))])])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }